import { createFileRoute } from '@tanstack/react-router';
import CreateUser from '../../../features/management/users/user/create';
import {
  createPermissionGuard,
  getPermissionSet,
  USER_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/benutzer/neu')({
  component: CreateUser,
  beforeLoad: createPermissionGuard(
    getPermissionSet(USER_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateUserRoute = Route;
